import * as React from "react";
import { Field } from "react-final-form";

export default class CheckBoxEnvio extends React.Component<CheckBoxEnvioProps> {

    render() {
        const { className } = this.props;

        return (
            <Field name={this.props.name} type="checkbox">
                {({ input, meta }) => (
                    <div>
                        <div>
                            <span className="input-group-addon cursor-auto" >
                                <input type="checkbox" aria-label="..." {...input} style={{width: '13px', height: '20px'}}
                                    className={className ? className.concat(" form-control") : "form-control"} />
                            </span>
                        </div>
                        <div>
                            {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                        </div>
                    </div>
                )}
            </Field>
        );
    }

}

interface CheckBoxEnvioProps {
    name: string,
    className?: string
}



// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general/componentes/CheckBoxEnvio.tsx